/**
 * Engine bo'ylab umumiy tiplar.
 *
 * Birliklar: to'liq SI, massa asosida.
 *   harorat  K       bosim   Pa      sarf  kg/s
 *   Cp       J/(kg·K) issiqlik W     yuza  m²
 * UI qatlami °C va boshqa qulay birliklarga o'zi aylantiradi.
 */

export type Severity = 'info' | 'warning' | 'critical';

/**
 * Ogohlantirish. `code` — i18n kaliti (masalan `hx.temperatureCross`),
 * matn engine ichida saqlanmaydi. `params` — matn shablonini to'ldirish uchun.
 */
export interface Warning {
  code: string;
  severity: Severity;
  params?: Record<string, number | string>;
}

/** Ogohlantirishlarni yig'ish uchun oddiy massiv. Sof funksiyalar unga push qiladi. */
export type WarningSink = Warning[];

export function warn(
  sink: WarningSink | undefined,
  code: string,
  severity: Severity = 'warning',
  params?: Record<string, number | string>,
): void {
  if (!sink) return;
  // Bir xil ogohlantirish takrorlanmasin (dinamik rejimda har qadamda chaqiriladi)
  const key = params ? JSON.stringify(params) : '';
  for (const w of sink) {
    if (w.code === code && (w.params ? JSON.stringify(w.params) : '') === key) return;
  }
  sink.push(params ? { code, severity, params } : { code, severity });
}

/**
 * Har bir apparat modeli shu interfeysga amal qiladi.
 *   P — konstruktiv parametrlar (yuza, quvurlar soni, ...)
 *   I — kirish oqimlari va boshqaruv (sarf, harorat, ...)
 *   S — dinamik holat (haroratlar massivi, ...)
 *   O — dinamik qadam chiqishlari (Tout(t), oniy Q, ...)
 *   SO — turg'un rejim chiqishlari (standart O bilan bir xil)
 */
export interface UnitModel<P, I, S, O, SO = O> {
  readonly id: string;
  /**
   * Lab parametrlarini (variant qo'llangandan keyin) to'liq ko'rinishga keltirish —
   * masalan reaksiya kutubxonasiga havolani (`{ library: id }`) kinetik konstantalarga ochish.
   * Natija sessiyaning `resolved.params` ida saqlanadi (hisobot etalonlari, mnemosxema uchun).
   */
  resolveParams?(params: P): P;
  init(params: P, inputs: I): S;
  step(params: P, state: S, inputs: I, dt: number): StepResult<S, O>;
  steady(params: P, inputs: I): SteadyResult<SO>;
}

export interface StepResult<S, O> {
  state: S;
  outputs: O;
  warnings: Warning[];
}

export interface SteadyResult<O> {
  outputs: O;
  warnings: Warning[];
  /** Solver diagnostikasi: iteratsiyalar, qoldiq, konvergensiya. */
  diagnostics: SolverDiagnostics;
}

export interface SolverDiagnostics {
  converged: boolean;
  iterations: number;
  residual: number;
  /** Konvergensiya bo'lmaganda sabab (i18n kaliti). */
  message?: string;
}

export type Phase = 'liquid' | 'gas';
